<div class="modulo">
    <figure>
        <img src="/images/modulo/logo/{{data.params.imagem}}" alt="Igreja Greenhouse" width="200px" />
    </figure>    
</div>    